import { useQuery } from 'react-query';
import * as plansService from '../services/plansService';


export const useGetPlans = (options = {}) => {
  return useQuery<any, Error>({
    queryKey: ['plans'],
    queryFn: plansService.getPlans,
    ...options
  });
}


export const useGetCurrentPlan = (options = {}) => {
  return useQuery<any, Error>({
    queryKey: ['current-plan'],
    queryFn: plansService.getCurrentPlan,
    ...options
  });
}

export const useGetNextPlan = (options = {}) => {
  return useQuery<any, Error>({
    queryKey: ['next-plan'],
    queryFn: plansService.getNextPlan,
    ...options
  });
}
